// Version : 0.0.1
// Author : VISHNU
// LastEdit : KARTHEESWARAN
//Last ADD : ADDING EMPTY ARRAY
// MODFIED DATA:30-07-2025
import GeneralActionTypes from './general.types';
import { docodeHexResponse } from '../_common/common.utils';

const INITIAL_STATE = {
	isDetailsEdit: false,
	isOffcanvasOpen: false,

	getCountryListResponse: [],
	getCountryListToken: null,

	getStateListResponse: null,
	getStateListToken: [],

	getCityListArr: [],
	getCityListResponse: null,

	getDistrictListResponse: null,
	getDistrictListArr: [],

	getIndustryListResponse: null,
	getAllIndustryListArr: [],

	getSubIndustryListResponse: null,
	getSubIndustryListArr: [],

	fetchAllBranchesResponse: null,
	fetchAllBranchesArr: [],

	fetchAllPurposeOfLoanListResponse: null,
	fetchAllPurposeOfLoanListArr: [],

	fetchAllPurposeOfLoanTypeResponse: null,
	fetchAllPurposeOfLoanTypeArr: [],

	fetchAllBusinessResponse: null,
	fetchAllBusinessArr: [],

	// Fetch All Product Types
	fetchAllProductTypesResponse: null,
	fetchAllProductTypesArr: [],

	// Fetch Pincode Details
	fetchPincodeDetailsArr: [],
	fetchPincodeDetailsResponse: null,

	fetchAllProductListResponse: null,
	fetchAllProductListArr: [],

	fetchAllBranchOfficerResponse: null,
	fetchAllBranchOfficerArr: [],

	fetchAllCenterResponse: null,
	fetchAllCenterArr: [],

	fetchAllInverstorResponse: null,
	fetchAllInverstorArr: [],

	fetchallGroupResponse: null,
	fetchallGroupArr: [],

	fetchCenterGroupResponse: null,
	fetchCenterGroupArr: [],

	fetchGroupMemberResponse: null,
	fetchGroupMemberArr: [],

	getPinCodeListResponse: [],

	fetchBranchAccountListResponse: null,
	fetchBranchAccountListArr: [],

	fetchGroupLoanIndexListResponse: null,
	fetchGroupLoanIndexListArr: [],

	fetchSearchLoanIndexListResponse: null,
	fetchSearchLoanIndexListArr: [],

	fetchVersionResponse: null,
	fetchVersionArr: [],

	getLocationListBasedLevelResponse: null,
	getLocationListBasedLevelArray: [],

	checkGoogleAuthenticationResponse: null,

	getPurposeOfLoanProposalListResp: null,
	getPurposeOfLoanProposalListArr: [],

	getOfficerBesedOnLevelListProposalResp: null,
	getOfficerBesedOnLevelListProposalArr: [],

	// Get Thrift List Proposal
	getThriftListProposalResp: null,
	getThriftListProposalArr: [],

	getThriftDetailsResp: null,
	getThriftDetailsArr: [],

	getThriftTwoDetailsArr: [],
	getThriftTwoDetailsResp: null,

	getNonApproveMembersDetailsResp: null,
	getNonApproveMembersDetailsArr: [],

	todayGoldPriceResponse: null,
	getTodayGoldPriceArr: [],

	getStatewisebranchesDetailsResp: null,
	getStatewisebranchesDetailsArr: [],

	updateTodayGoldPriceRep: null,

	// Generic pincode state - stores data by field type
	genericPincodeData: {},
	genericPincodeResponse: {},
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** EDIT DETAILS START *********************** */
		case GeneralActionTypes.IS_EDIT_DETAILS_START:
			return { ...state, isDetailsEdit: action.payload };

		/** ***************** EDIT DETAILS END *********************** */

		/** ***************** OFFCANVAS START *********************** */
		case GeneralActionTypes.IS_OPEN_OFFCANVAS_START:
			return { ...state, isOffcanvasOpen: action.payload };
		/** ***************** OFFCANVAS END *********************** */

		/** ***************** GET COUNTRY LIST START *********************** */
		case GeneralActionTypes.GET_COUNTRY_LIST_SUCCESS:
			return {
				...state,
				getCountryListResponse: docodeHexResponse(action.payload, 'GetCountryListKey'),
				getCountryListToken: action.payload,
			};

		case GeneralActionTypes.GET_COUNTRY_LIST_FAILURE:
			return { ...state, getCountryListResponse: [] };

		case GeneralActionTypes.GET_COUNTRY_LIST_RESPONSE_CHANGED:
			return { ...state, getCountryListToken: null };
		/** ***************** GET COUNTRY LIST END *********************** */

		/** ***************** GET STATE LIST START *********************** */
		case GeneralActionTypes.GET_STATE_LIST_SUCCESS:
			return {
				...state,
				getStateListToken: docodeHexResponse(action.payload, 'CountryStateListGetKey'),
				getStateListResponse: action.payload,
			};

		case GeneralActionTypes.GET_STATE_LIST_FAILURE:
			return { ...state, getStateListResponse: action.payload };

		case GeneralActionTypes.GET_STATE_LIST_RESPONSE_CHANGED:
			return { ...state, getStateListResponse: null };
		/** ***************** GET STATE LIST END *********************** */

		/** ***************** GET CITY LIST START *********************** */
		case GeneralActionTypes.GET_CITY_LIST_SUCCESS:
			return {
				...state,
				getCityListArr: docodeHexResponse(action.payload, 'StateCityListGetKey'),
				getCityListResponse: action.payload,
			};

		case GeneralActionTypes.GET_CITY_LIST_FAILURE:
			return { ...state, getCityListResponse: action.payload };

		case GeneralActionTypes.GET_CITY_LIST_RESPONSE_CHANGED:
			return { ...state, getCityListResponse: null };
		/** ***************** GET CITY LIST END *********************** */

		/** ***************** GET DISTRICT LIST START *********************** */
		case GeneralActionTypes.GET_DISTRICT_LIST_SUCCESS:
			return {
				...state,
				getDistrictListArr: docodeHexResponse(action.payload, 'DistrictCityListGetKey'),
				getDistrictListResponse: action.payload,
			};
		case GeneralActionTypes.GET_DISTRICT_LIST_FAILURE:
			return {
				...state,
				getDistrictListResponse: action.payload,
			};
		case GeneralActionTypes.GET_DISTRICT_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getDistrictListResponse: null,
			};
		/** ***************** GET DISTRICT LIST END *********************** */

		/** ***************** GET PINCODE LIST START *********************** */
		case GeneralActionTypes.GET_PINCODE_LIST_SUCCESS:
			return {
				...state,
				getPinCodeListResponse: action.payload.PostOffice,
			};
		case GeneralActionTypes.GET_PINCODE_LIST_FAILURE:
			return { ...state, getPinCodeListResponse: [] };

		case GeneralActionTypes.GET_PINCODE_LIST_RESPONSE_CHANGED:
			return { ...state, getPinCodeListResponse: [] };
		/** ***************** GET PINCODE LIST END *********************** */

		/** ***************** GET INDUSTRY LIST START *********************** */
		case GeneralActionTypes.GET_INDUSTRY_LIST_SUCCESS:
			return {
				...state,
				getIndustryListResponse: action.payload,
				getAllIndustryListArr: docodeHexResponse(action.payload, 'GetAllIndustryListKey'),
			};

		case GeneralActionTypes.GET_INDUSTRY_LIST_FAILURE:
			return { ...state, getIndustryListResponse: action.payload };

		case GeneralActionTypes.GET_INDUSTRY_LIST_RESPONSE_CHANGED:
			return { ...state, getIndustryListResponse: null };
		/** ***************** GET INDUSTRY LIST END *********************** */

		/** ***************** GET SUB INDUSTRY LIST START *********************** */
		case GeneralActionTypes.GET_SUB_INDUSTRY_LIST_SUCCESS:
			return {
				...state,
				getSubIndustryListResponse: action.payload,
				getSubIndustryListArr: docodeHexResponse(action.payload, 'GetSubIndustryListKey'),
			};

		case GeneralActionTypes.GET_SUB_INDUSTRY_LIST_FAILURE:
			return { ...state, getSubIndustryListResponse: action.payload };

		case GeneralActionTypes.GET_SUB_INDUSTRY_LIST_RESPONSE_CHANGED:
			return { ...state, getSubIndustryListResponse: null };
		/** ***************** GET SUB INDUSTRY LIST END *********************** */

		/** ***************** GET ALL BRANCHES START *********************** */
		case GeneralActionTypes.FETCH_ALL_BRANCHES_SUCCESS:
			return {
				...state,
				fetchAllBranchesResponse: action.payload,
				fetchAllBranchesArr: docodeHexResponse(action.payload, 'FetchAllBranchKey'),
			};

		case GeneralActionTypes.FETCH_ALL_BRANCHES_FAILURE:
			return { ...state, fetchAllBranchesResponse: action.payload, fetchAllBranchesArr: [] };

		case GeneralActionTypes.FETCH_ALL_BRANCHES_RESPONSE_CHANGED:
			return { ...state, fetchAllBranchesResponse: null };
		/** ***************** GET ALL BRANCHES END *********************** */

		/** ***************** GET ALL PURPOSE OF LOAN LIST START *********************** */
		case GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_SUCCESS:
			return {
				...state,
				fetchAllPurposeOfLoanListResponse: action.payload,
				fetchAllPurposeOfLoanListArr: docodeHexResponse(
					action.payload,
					'FetchAllPurposeOfLoansKey',
				),
			};

		case GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_FAILURE:
			return { ...state, fetchAllPurposeOfLoanListResponse: action.payload };

		case GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_LIST_RESPONSE_CHANGED:
			return { ...state, fetchAllPurposeOfLoanListResponse: null };
		/** ***************** GET ALL PURPOSE OF LOAN LIST END *********************** */

		/** ***************** GET ALL PURPOSE OF LOAN TYPE START *********************** */
		case GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_SUCCESS:
			return {
				...state,
				fetchAllPurposeOfLoanTypeResponse: action.payload,
				fetchAllPurposeOfLoanTypeArr: docodeHexResponse(
					action.payload,
					'FetchAllPurposeOfLoanTypesKey',
				),
			};

		case GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_FAILURE:
			return { ...state, fetchAllPurposeOfLoanTypeResponse: action.payload };

		case GeneralActionTypes.FETCH_ALL_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED:
			return { ...state, fetchAllPurposeOfLoanTypeResponse: null };
		/** ***************** GET ALL PURPOSE OF LOAN TYPE END *********************** */

		/** ***************** GET ALL BUSINESS LIST START *********************** */
		case GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_SUCCESS:
			return {
				...state,
				fetchAllBusinessResponse: action.payload,
				fetchAllBusinessArr: docodeHexResponse(action.payload, 'GetAllBusinessListKey'),
			};

		case GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_FAILURE:
			return { ...state, fetchAllBusinessResponse: action.payload };

		case GeneralActionTypes.FETCH_ALL_BUSINESS_LIST_RESPONSE_CHANGED:
			return { ...state, fetchAllBusinessResponse: null };
		/** ***************** GET ALL BUSINESS LIST END *********************** */

		/** ***************** GET ALL PRODUCT TYPE START *********************** */
		case GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_SUCCESS:
			return {
				...state,
				fetchAllProductTypesResponse: action.payload,
				fetchAllProductTypesArr: docodeHexResponse(
					action.payload,
					'FetchAllProductTypesKey',
				),
			};

		case GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_FAILURE:
			return { ...state, fetchAllProductTypesResponse: action.payload };

		case GeneralActionTypes.FETCH_ALL_PRODUCT_TYPE_RESPONSE_CHANGED:
			return { ...state, fetchAllProductTypesResponse: null };
		/** ***************** GET ALL PRODUCT TYPE END *********************** */

		/** ***************** GET ALL PRODUCT LIST START *********************** */
		case GeneralActionTypes.FETCH_ALL_PRODUCT_SUCCESS:
			return {
				...state,
				fetchAllProductListResponse: action.payload,
				fetchAllProductListArr: docodeHexResponse(action.payload, 'FetchAllProductList'),
			};

		case GeneralActionTypes.FETCH_ALL_PRODUCT_FAILURE:
			return {
				...state,
				fetchAllProductListResponse: action.payload,
				fetchAllProductListArr: [],
			};

		case GeneralActionTypes.FETCH_ALL_PRODUCT_RESPONSE_CHANGED:
			return { ...state, fetchAllProductListResponse: null };
		/** ***************** GET ALL PRODUCT LIST END *********************** */

		/** ***************** GET ALL BRANCH OFFICER START *********************** */
		case GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_SUCCESS:
			return {
				...state,
				fetchAllBranchOfficerResponse: action.payload,
				fetchAllBranchOfficerArr: docodeHexResponse(
					action.payload,
					'GetAllBranchOfficerList',
				),
			};

		case GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_FAILURE:
			return { ...state, fetchAllBranchOfficerResponse: action.payload };

		case GeneralActionTypes.FETCH_ALL_BRANCH_OFFICER_RESPONSE_CHANGED:
			return { ...state, fetchAllBranchOfficerResponse: null };
		/** ***************** GET ALL BRANCH OFFICER END *********************** */

		/** ***************** GET ALL CENTER START *********************** */
		case GeneralActionTypes.FETCH_ALL_CENTERS_SUCCESS:
			return {
				...state,
				fetchAllCenterResponse: action.payload,
				fetchAllCenterArr: docodeHexResponse(action.payload, 'GetAllCentersList'),
			};

		case GeneralActionTypes.FETCH_ALL_CENTERS_FAILURE:
			return { ...state, fetchAllCenterResponse: action.payload, fetchAllCenterArr: [] };

		case GeneralActionTypes.FETCH_ALL_CENTERS_RESPONSE_CHANGED:
			return { ...state, fetchAllCenterResponse: null };
		/** ***************** GET ALL CENTER END *********************** */

		/** ***************** GET ALL INVESTOR START *********************** */
		case GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_SUCCESS:
			return {
				...state,
				fetchAllInverstorResponse: action.payload,
				fetchAllInverstorArr: docodeHexResponse(action.payload, 'GetAllInvestorListKey'),
			};

		case GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_FAILURE:
			return { ...state, fetchAllInverstorResponse: action.payload };

		case GeneralActionTypes.FETCH_ALL_INVESTOR_LIST_RESPONSE_CHANGED:
			return { ...state, fetchAllInverstorResponse: null };
		/** ***************** GET ALL INVESTOR END *********************** */

		case GeneralActionTypes.RESET_ALL_REDUCER_STATE_START:
			return INITIAL_STATE;

		/** ***************** GET ALL GROUP START *********************** */
		case GeneralActionTypes.FETCH_ALL_GROUP_LIST_SUCCESS:
			return {
				...state,
				fetchallGroupResponse: action.payload,
				fetchallGroupArr: docodeHexResponse(action.payload, 'GetAllGroupsListkey'),
			};

		case GeneralActionTypes.FETCH_ALL_GROUP_LIST_FAILURE:
			return { ...state, fetchallGroupResponse: action.payload };

		case GeneralActionTypes.FETCH_ALL_GROUP_LIST_RESPONSE_CHANGED:
			return { ...state, fetchallGroupResponse: null };
		/** ***************** GET ALL GROUP END *********************** */

		/** ***************** GET ALL CENTER GROUP START *********************** */
		case GeneralActionTypes.FETCH_CENTER_GROUPS_SUCCESS:
			return {
				...state,
				fetchCenterGroupResponse: action.payload,
				fetchCenterGroupArr: docodeHexResponse(action.payload, 'FetchAllGroupListKey'),
			};

		case GeneralActionTypes.FETCH_CENTER_GROUPS_FAILURE:
			return { ...state, fetchCenterGroupResponse: action.payload };

		case GeneralActionTypes.FETCH_CENTER_GROUPS_RESPONSE_CHANGED:
			return { ...state, fetchCenterGroupResponse: null };
		/** ***************** GET ALL CENTER GROUP END *********************** */

		/** ***************** GET ALL GROUP MEMBER START *********************** */
		case GeneralActionTypes.FETCH_GROUP_MEMBERS_SUCCESS:
			return {
				...state,
				fetchGroupMemberResponse: action.payload,
				fetchGroupMemberArr: docodeHexResponse(action.payload, 'FetchGroupMembersListKey'),
			};

		case GeneralActionTypes.FETCH_GROUP_MEMBERS_FAILURE:
			return { ...state, fetchGroupMemberResponse: action.payload };

		case GeneralActionTypes.FETCH_GROUP_MEMBERS_RESPONSE_CHANGED:
			return { ...state, fetchGroupMemberResponse: null };
		/** ***************** GET ALL GROUP MEMBER END *********************** */

		/** ***************** GET ALL BRANCH ACCOUNT START *********************** */
		case GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_SUCCESS:
			return {
				...state,
				fetchBranchAccountListResponse: action.payload,
				fetchBranchAccountListArr: docodeHexResponse(
					action.payload,
					'FetchBranchAccountDetailsKey',
				),
			};

		case GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_FAILURE:
			return { ...state, fetchBranchAccountListResponse: action.payload };

		case GeneralActionTypes.FETCH_BRANCH_ACCOUNT_LIST_RESPONSE_CHANGED:
			return { ...state, fetchBranchAccountListResponse: null };
		/** ***************** GET ALL BRANCH ACCOUNT END *********************** */

		/** ***************** GET ALL LOAN INDEX BASED GROUP START *********************** */
		case GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_SUCCESS:
			return {
				...state,
				fetchGroupLoanIndexListResponse: action.payload,
				fetchGroupLoanIndexListArr: docodeHexResponse(
					action.payload,
					'FetchAllLoanIndexListKey',
				),
			};

		case GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_FAILURE:
			return { ...state, fetchGroupLoanIndexListResponse: action.payload };

		case GeneralActionTypes.FETCH_LOAN_INDEX_BASED_GROUP_RESPONSE_CHANGED:
			return { ...state, fetchGroupLoanIndexListResponse: null };
		/** ***************** GET ALL LOAN INDEX BASED GROUP END *********************** */

		/** ***************** GET ALL SEARCH LOAN INDEX START *********************** */
		case GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_SUCCESS:
			return {
				...state,
				fetchSearchLoanIndexListResponse: action.payload,
				fetchSearchLoanIndexListArr: docodeHexResponse(
					action.payload,
					'SearchLoanIndexDetailsTokenKey',
				),
			};

		case GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_FAILURE:
			return { ...state, fetchSearchLoanIndexListResponse: action.payload };

		case GeneralActionTypes.FETCH_SEARCH_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, fetchSearchLoanIndexListResponse: null };
		/** ***************** GET ALL SEARCH LOAN INDEX END *********************** */

		/** ***************** GET ALL VERSION START *********************** */
		case GeneralActionTypes.FETCH_VERSION_SUCCESS:
			return {
				...state,
				fetchVersionResponse: action.payload,
				fetchVersionArr: docodeHexResponse(action.payload, 'GetVersionDataKey'),
			};

		case GeneralActionTypes.FETCH_VERSION_FAILURE:
			return { ...state, fetchVersionResponse: action.payload };

		case GeneralActionTypes.FETCH_VERSION_RESPONSE_CHANGED:
			return { ...state, fetchVersionResponse: null };
		/** ***************** GET ALL VERSION END *********************** */

		/** ***************** UPDATE VERSION START *********************** */
		case GeneralActionTypes.UPDATE_VERSION_SUCCESS:
			return {
				...state,
				updateVersionResponse: action.payload,
				updateVersionArr: docodeHexResponse(action.payload, 'UpdateVersionDataKey'),
			};

		case GeneralActionTypes.UPDATE_VERSION_FAILURE:
			return { ...state, updateVersionResponse: action.payload };

		case GeneralActionTypes.UPDATE_VERSION_RESPONSE_CHANGED:
			return { ...state, updateVersionResponse: null };
		/** ***************** UPDATE VERSION END *********************** */

		/** *****************FETCH PINCODE DETAILS START *********************** */
		case GeneralActionTypes.FETCH_PINCODE_DETAILS_SUCCESS:
			return {
				...state,
				fetchPincodeDetailsResponse: action.payload,
				fetchPincodeDetailsArr: docodeHexResponse(action.payload, 'FetchPincodeListKey'),
			};

		case GeneralActionTypes.FETCH_PINCODE_DETAILS_FAILURE:
			return {
				...state,
				fetchPincodeDetailsResponse: action.payload,
				fetchPincodeDetailsArr: [],
			};

		case GeneralActionTypes.FETCH_PINCODE_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchPincodeDetailsResponse: null };
		/** *****************FETCH PINCODE DETAILS END *********************** */

		/** ***************** GENERIC PINCODE DETAILS START *********************** */
		case GeneralActionTypes.GENERIC_PINCODE_DETAILS_SUCCESS:
			return {
				...state,
				genericPincodeResponse: {
					...state.genericPincodeResponse,
					[action.payload.fieldType]: action.payload.successData,
				},
				genericPincodeData: {
					...state.genericPincodeData,
					[action.payload.fieldType]: docodeHexResponse(
						action.payload.successData,
						'FetchPincodeListKey',
					),
				},
			};

		case GeneralActionTypes.GENERIC_PINCODE_DETAILS_FAILURE:
			return {
				...state,
				genericPincodeResponse: {
					...state.genericPincodeResponse,
					[action.payload.fieldType]: action.payload.errorData,
				},
				genericPincodeData: {
					...state.genericPincodeData,
					[action.payload.fieldType]: [],
				},
			};

		case GeneralActionTypes.GENERIC_PINCODE_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				genericPincodeResponse: {
					...state.genericPincodeResponse,
					[action.payload.fieldType]: null,
				},
			};
		/** ***************** GENERIC PINCODE DETAILS END *********************** */

		/** ***************** GET ALL LOAN INDEX BASED GROUP START *********************** */
		case GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_SUCCESS:
			return {
				...state,
				getLocationListBasedLevelResponse: action.payload,
				getLocationListBasedLevelArray: docodeHexResponse(
					action.payload,
					'AllLocationBasedLevelKey',
				),
			};

		case GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_FAILURE:
			return { ...state, getLocationListBasedLevelResponse: action.payload };

		case GeneralActionTypes.GET_LOCATION_LIST_BASED_LEVEL_RESPONSE_CHANGED:
			return { ...state, getLocationListBasedLevelResponse: null };
		/** ***************** GET ALL LOAN INDEX BASED GROUP END *********************** */

		/** ***************** CHECK GOOGLE AUTHENTICATION START *********************** */
		case GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_SUCCESS:
			return {
				...state,
				checkGoogleAuthenticationResponse: action.payload,
			};

		case GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_FAILURE:
			return { ...state, checkGoogleAuthenticationResponse: action.payload };

		case GeneralActionTypes.CHECK_GOOGLE_AUTHENTICATION_RESPONSE_CHANGED:
			return { ...state, checkGoogleAuthenticationResponse: null };
		/** ***************** CHECK GOOGLE AUTHENTICATION END *********************** */

		/** ***************** GET PURPOSE OF LOAN PROPOSAL START *********************** */
		case GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_SUCCESS:
			return {
				...state,
				getPurposeOfLoanProposalListResp: action.payload,
				getPurposeOfLoanProposalListArr: docodeHexResponse(
					action.payload,
					'getAllPurposeOfLoanListDetailsKey',
				),
			};

		case GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_FAILURE:
			return { ...state, getPurposeOfLoanProposalListResp: action.payload };

		case GeneralActionTypes.GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED:
			return { ...state, getPurposeOfLoanProposalListResp: null };
		/** ***************** GET PURPOSE OF LOAN PROPOSAL END *********************** */

		/** ***************** GET OFFICER BASED ON LEVEL START *********************** */
		case GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_SUCCESS:
			return {
				...state,
				getOfficerBesedOnLevelListProposalResp: action.payload,
				getOfficerBesedOnLevelListProposalArr: docodeHexResponse(
					action.payload,
					'GetAllOfficerUserBasedOnLevelKey',
				),
			};

		case GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_FAILURE:
			return { ...state, getOfficerBesedOnLevelListProposalResp: action.payload };

		case GeneralActionTypes.GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, getOfficerBesedOnLevelListProposalResp: null };
		/** ***************** GET OFFICER BASED ON LEVEL END *********************** */

		/** ***************** GET THRIFT LIST PROPOSAL START *********************** */
		case GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_SUCCESS:
			return {
				...state,
				getThriftListProposalResp: action.payload,
				getThriftListProposalArr: docodeHexResponse(action.payload, 'getAllThriftListKey'),
			};

		case GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_FAILURE:
			return { ...state, getThriftListProposalResp: action.payload };

		case GeneralActionTypes.GET_THRIFT_LIST_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, getThriftListProposalResp: null };
		/** ***************** GET THRIFT LIST PROPOSAL END *********************** */

		/** ***************** GET THRIFT DETAILS START *********************** */
		case GeneralActionTypes.GET_THRIFT_DETAILS_SUCCESS:
			return {
				...state,
				getThriftDetailsResp: action.payload,
				getThriftDetailsArr: docodeHexResponse(
					action.payload,
					'GetThriftDetailsTokenDataKey',
				),
			};

		case GeneralActionTypes.GET_THRIFT_DETAILS_FAILURE:
			return { ...state, getThriftDetailsResp: action.payload, getThriftDetailsArr: [] };

		case GeneralActionTypes.GET_THRIFT_DETAILS_RESPONSE_CHANGED:
			return { ...state, getThriftDetailsResp: null };
		/** ***************** GET THRIFT DETAILS END *********************** */

		/** ***************** GET THRIFT TWO DETAILS START *********************** */
		case GeneralActionTypes.GET_THRIFT_TWO_DETAILS_SUCCESS:
			return {
				...state,
				getThriftTwoDetailsResp: action.payload,
				getThriftTwoDetailsArr: docodeHexResponse(
					action.payload,
					'GetThriftDetailsTokenDataKey',
				),
			};

		case GeneralActionTypes.GET_THRIFT_TWO_DETAILS_FAILURE:
			return { ...state, getThriftTwoDetailsResp: action.payload };

		case GeneralActionTypes.GET_THRIFT_TWO_DETAILS_RESPONSE_CHANGED:
			return { ...state, getThriftTwoDetailsResp: null };
		/** ***************** GET THRIFT TWO DETAILS END *********************** */

		/** ***************** GET NON APPROVE MEMBERS DETAILS START *********************** */
		case GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_SUCCESS:
			return {
				...state,
				getNonApproveMembersDetailsResp: action.payload,
				getNonApproveMembersDetailsArr: docodeHexResponse(
					action.payload,
					'FetchAllNonApproveMembersKey',
				),
			};

		case GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_FAILURE:
			return { ...state, getNonApproveMembersDetailsResp: action.payload };

		case GeneralActionTypes.GET_NON_APPROVE_MEMBERS_DETAILS_RESPONSE_CHANGED:
			return { ...state, getNonApproveMembersDetailsResp: null };
		/** ***************** GET NON APPROVE MEMBERS DETAILS END *********************** */

		/** ***************** GET TODAY GOLD PRICE START *********************** */
		case GeneralActionTypes.GET_TODAY_GOLD_PRICE_SUCCESS:
			return {
				...state,
				todayGoldPriceResponse: action.payload,
				getTodayGoldPriceArr: docodeHexResponse(action.payload, 'GetTodayGoldPriceKey'),
			};

		case GeneralActionTypes.GET_TODAY_GOLD_PRICE_FAILURE:
			return {
				...state,
				todayGoldPriceResponse: action.payload,
				getTodayGoldPriceArr: [],
			};

		case GeneralActionTypes.GET_TODAY_GOLD_PRICE_RESPONSE_CHANGED:
			return { ...state, todayGoldPriceResponse: null };
		/** ***************** GET TODAY GOLD PRICE END *********************** */

		/** ***************** UPDATE TODAY GOLD PRICE START *********************** */
		case GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_SUCCESS:
			return {
				...state,
				updateTodayGoldPriceRep: action.payload,
			};

		case GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_FAILURE:
			return {
				...state,
				updateTodayGoldPriceRep: action.payload,
			};

		case GeneralActionTypes.UPDATE_TODAY_GOLD_PRICE_RESPONSE_CHANGED:
			return { ...state, updateTodayGoldPriceRep: null };
		/** ***************** UPDATE TODAY GOLD PRICE END *********************** */
		/** ***************** UPDATE TODAY GOLD PRICE START *********************** */
		case GeneralActionTypes.GET_STATEWISW_BRANCHES_SUCCESS:
			return {
				...state,
				getStatewisebranchesDetailsResp: action.payload,
				getStatewisebranchesDetailsArr: docodeHexResponse(
					action.payload,
					'FetchLoadAdminAreaList',
				),
			};

		case GeneralActionTypes.GET_STATEWISW_BRANCHES_FAILURE:
			return {
				...state,
				getStatewisebranchesDetailsResp: action.payload,
				getStatewisebranchesDetailsArr: [],
			};

		case GeneralActionTypes.GET_STATEWISW_BRANCHES_RESPONSE_CHANGED:
			return { ...state, getStatewisebranchesDetailsResp: null };
		/** ***************** UPDATE TODAY GOLD PRICE END *********************** */

		default:
			return state;
	}
};
